// ============================================================
// Where the backend lives.
//
// VITE_API_URL is the backend's public origin, e.g.
// https://wacrmapi.conprgtech.com (baked in at build time). Every API
// request, file upload, media URL and the Socket.IO connection is built
// from it. Left empty, requests stay relative to the page's own origin.
//
// Requests are cross-origin, so they always send credentials — the
// backend's httpOnly session cookies — and the backend must allow this
// site in CORS (SITE_URL / CORS_ORIGINS in backend/.env).
// ============================================================

export const API_ORIGIN: string = (import.meta.env.VITE_API_URL ?? "").trim().replace(/\/+$/, "");

/** Absolute URL for a backend path. Non-`/api` and absolute URLs pass through. */
export function apiUrl(path: string): string {
  if (!path || !API_ORIGIN) return path;
  return path.startsWith("/api/") || path === "/api" ? `${API_ORIGIN}${path}` : path;
}

/**
 * `fetch` for backend calls: resolves `/api/...` against VITE_API_URL and
 * always includes the session cookies. Any other URL is fetched as-is.
 */
export function apiFetch(input: string | URL | Request, init?: RequestInit): Promise<Response> {
  if (typeof input === "string") {
    const url = apiUrl(input);
    const isApi = url !== input || input.startsWith("/api");
    return fetch(url, isApi ? { credentials: "include", ...init } : init);
  }
  return fetch(input, init);
}
